// components/TermsModal/TermsModal.jsx
import { Modal, Button, Text, ScrollArea, Divider } from "@mantine/core";

const TermsModal = ({ opened, onAccept, onClose }) => {
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            size="lg"
            closeOnClickOutside={true}
        >
            <ScrollArea
                h={400}
            >
                <div className="terms-container" style={{color: '#fff'}}>
                    <header className="terms-header">
                        <h1>Términos y Condiciones de Venta y Uso</h1>
                        <p className="last-update">Actualizado: Enero 2026</p>
                    </header>

                    <section className="terms-intro">
                        <p style={{color: '#fff'}}> 
                            El presente documento establece las condiciones que regulan la compra de productos,
                            servicios y el uso de la plataforma de <strong>FORVET</strong>. Al realizar una compra en nuestro
                            sitio web, adquieres la condición de "Cliente" y aceptas estos términos en su totalidad.
                        </p>
                    </section>

                    <Divider color="#ffffff1b"/>

                    <div className="terms-content">
                        <section className="terms-section">
                            <h2 style={{color: "#fff"}}>1. Objeto y Contratación</h2>
                            <p style={{color: "#fff"}}>
                                FORVET ofrece servicios de formación y recursos educativos especializados. La contratación se perfecciona
                                en el momento en que se confirma el pago a través de nuestras pasarelas autorizadas.
                                Tras la compra, el cliente recibirá las credenciales de acceso al contenido digital
                                en el correo electrónico proporcionado.
                            </p>
                        </section>

                        <section className="terms-section">
                            <h2 style={{color: "#fff"}}>2. Propiedad Intelectual y Derechos de Autor</h2>
                            <p style={{color: "#fff"}}>
                                Todo el contenido didáctico, materiales audiovisuales, documentos y recursos proporcionados en esta plataforma
                                son propiedad intelectual de los <strong>docentes y autores respectivos</strong>. FORVET actúa como plataforma
                                autorizada para la explotación comercial y distribución de dichos contenidos, en virtud de los acuerdos
                                individuales establecidos con cada profesional.
                            </p>
                            <p style={{color: "#fff"}}>
                                La adquisición de un curso otorga al cliente una licencia de uso personal, privada y no exclusiva.
                                <strong> Está estrictamente prohibida</strong> la reproducción total o parcial, comunicación pública,
                                distribución, transformación o cualquier otra forma de explotación no autorizada de estos materiales.
                                Cualquier infracción será tratada conforme a las normativas vigentes de propiedad intelectual.
                            </p>
                        </section>

                        <section className="terms-section">
                            <h2 style={{color: "#fff"}}>3. Política de Devoluciones y Reembolsos</h2>
                            <p style={{color: "#fff"}}>
                                Para solicitar una devolución de dinero o realizar un reclamo sobre un pago, se deben seguir los siguientes lineamientos:
                            </p>
                            <ul style={{color: "#fff"}}>
                                <li>Las solicitudes deben ser justificadas y enviadas formalmente por escrito.</li>
                                <li>Se analizará cada caso de manera particular en función de los hechos expuestos.</li>
                            </ul>
                        </section>

                        <section className="terms-contact-box">
                            <h3>Atención al Cliente y Reclamos</h3>
                            <p style={{color: '#333'}}>
                                Para cualquier gestión administrativa, técnica o solicitud de devolución, por favor diríjase a:
                            </p>
                            <div style={{color: '#333'}} className="contact-details">
                                <span className="email-label">Email:</span>
                                <a href="mailto:administracion@forvet.org" className="email-link"> administracion@forvet.org</a>
                            </div>
                            <p  className="response-time">
                                * Nuestro compromiso es brindarte una solución rápida. Recibirás una respuesta en un plazo máximo de <strong>hasta 48hs hábiles</strong>.
                            </p>
                        </section>

                        <section className="terms-section">
                            <h2 style={{color: "#fff"}}>4. Normas de Convivencia y Acceso</h2>
                            <p style={{color: "#fff"}}>
                                El acceso al campus virtual requiere un comportamiento ético. FORVET se reserva el derecho de
                                suspender el acceso a usuarios que incurran en prácticas de piratería, compartan credenciales
                                de acceso con terceros o falten al respeto a los docentes y demás alumnos en los espacios de comunidad.
                            </p>
                        </section>
                    </div>

                    <footer className="terms-footer">
                        <p style={{color: "#fff"}}>© {new Date().getFullYear()} FORVET</p>
                    </footer>
                </div>
            </ScrollArea>

            <Button
                fullWidth
                type='button'
                mt="md"
                onClick={onAccept}
            >
                Aceptar y continuar
            </Button>
        </Modal>
    );
};

export default TermsModal;